import classNames from "classnames";
import _ from "lodash";
import * as React from "react";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import scottifyStyles from "../styles/scottify/Scottify.module.scss";
import pageStyles from "../styles/shared/Page.module.scss";
import Controls from "./components/Controls";
import ScottifyBody from "./components/ScottifyBody";
import ScottifyMobileBody from "./components/ScottifyMobileBody";
import { Playlist, PLAYLISTS } from "./data/ScottifyTwoData";

declare namespace ScottifyTwo {
  export interface Props {}
  export interface State {
    selectedPlaylist: Playlist;
  }
}

// eslint-disable-next-line no-redeclare
export default class ScottifyTwo extends React.Component<
  ScottifyTwo.Props,
  ScottifyTwo.State
> {
  state: ScottifyTwo.State = {
    selectedPlaylist: PLAYLISTS[0],
  };

  render() {
    return (
      <div
        className={classNames(pageStyles.page, scottifyStyles.scottifyPage, {
          [scottifyStyles.mobile]: isMobile,
        })}
      >
        {isMobile ? this.renderHeader() : null}
        <div className={scottifyStyles.scottifyPageBody}>
          {isMobile ? (
            <ScottifyMobileBody
              playlist={this.state.selectedPlaylist}
              selectPlaylist={this.selectPlaylist}
              nextPlaylist={this.nextPlaylist}
              previousPlaylist={this.previousPlaylist}
            />
          ) : (
            <ScottifyBody
              playlist={this.state.selectedPlaylist}
              selectPlaylist={this.selectPlaylist}
              nextPlaylist={this.nextPlaylist}
              previousPlaylist={this.previousPlaylist}
            />
          )}
        </div>
        <div className={scottifyStyles.scottifyPageFooter}>
          <Controls />
        </div>
      </div>
    );
  }

  private handleClickPlay = () => {
    window.open(
      "https://open.spotify.com/playlist/2upvTnzAS3EtKhxv92kg4m",
      "_blank"
    );
  };

  private selectPlaylist = (playlist: Playlist) => {
    this.setState({ selectedPlaylist: playlist });
  };

  private nextPlaylist = () => {
    const index = _.findIndex(PLAYLISTS, this.state.selectedPlaylist);
    if (index != null && index + 1 < PLAYLISTS.length) {
      this.setState({
        selectedPlaylist: PLAYLISTS[index + 1],
      });
    }
  };

  private previousPlaylist = () => {
    const index = _.findIndex(PLAYLISTS, this.state.selectedPlaylist);
    if (index != null && index > 0) {
      this.setState({
        selectedPlaylist: PLAYLISTS[index - 1],
      });
    }
  };

  private renderHeader = () => {
    return (
      <div className={scottifyStyles.scottifyPageHeader}>
        <Link className={scottifyStyles.webNavBarImage} to="/scottifytwo">
          <img
            className={scottifyStyles.rosterLogoImage}
            src="/img/scottify/ScottifyLogo.png"
            alt=""
          />
        </Link>
        <div className={scottifyStyles.horizontalSpacer} />
        {/* <Link className={scottifyStyles.webNavBarImage} to="/">
          <img
            className={scottifyStyles.rivalLogoImage}
            src="/img/scottify/Rlogo_white_small.png"
            alt=""
          />
        </Link> */}
      </div>
    );
  };
}
